import _defineProperty from "D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import { isNumber } from 'vega-util';
import { getViewConfigDiscreteStep } from '../../config';
import { isVgRangeStep } from '../../vega.schema';
import { getMarkPropOrConfig, signalOrValueRef } from '../common';
import * as encode from './encode';
export var tick = {
  vgMark: 'rect',
  encodeEntry: function encodeEntry(model) {
    var config = model.config,
      markDef = model.markDef;
    var orient = markDef.orient;
    var vgSizeChannel = orient === 'horizontal' ? 'width' : 'height';
    var vgThicknessChannel = orient === 'horizontal' ? 'height' : 'width';
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, encode.baseEncodeEntry(model, {
      align: 'ignore',
      baseline: 'ignore',
      color: 'include',
      orient: 'ignore',
      size: 'ignore',
      theta: 'ignore'
    })), encode.pointPosition('x', model, {
      defaultPos: 'mid',
      vgChannel: 'xc'
    })), encode.pointPosition('y', model, {
      defaultPos: 'mid',
      vgChannel: 'yc'
    })), encode.nonPosition('size', model, {
      defaultValue: defaultSize(model),
      vgChannel: vgSizeChannel
    })), _defineProperty({}, vgThicknessChannel, signalOrValueRef(getMarkPropOrConfig('thickness', markDef, config))));
  }
};
function defaultSize(model) {
  var _a;
  var config = model.config,
    markDef = model.markDef;
  var orient = markDef.orient;
  var vgSizeChannel = orient === 'horizontal' ? 'width' : 'height';
  var scale = model.getScaleComponent(orient === 'horizontal' ? 'x' : 'y');
  var markPropOrConfig = (_a = getMarkPropOrConfig('size', markDef, config, {
    vgChannel: vgSizeChannel
  })) !== null && _a !== void 0 ? _a : config.tick.bandSize;
  if (markPropOrConfig !== undefined) {
    return markPropOrConfig;
  } else {
    var scaleRange = scale ? scale.get('range') : undefined;
    if (scaleRange && isVgRangeStep(scaleRange) && isNumber(scaleRange.step)) {
      return scaleRange.step * 3 / 4;
    }
    var defaultViewStep = getViewConfigDiscreteStep(config.view, vgSizeChannel);
    return defaultViewStep * 3 / 4;
  }
}